import { render, staticRenderFns } from "./CustomPostContent.vue?vue&type=template&id=06f5a9ac&"
import script from "./CustomPostContent.vue?vue&type=script&lang=js&"
export * from "./CustomPostContent.vue?vue&type=script&lang=js&"
import style0 from "./CustomPostContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports